<div class="sidebar-container flex flex-col justify-between h-full">
    <div class="sidebar-pages flex flex-col">
        <img src="assets/images/logo_with_text.svg" priority />
        <div class="nav-link flex flex-col">
            @for (item of navItemsData; track item.id) {
            <app-nav-sidebar [item]="item"></app-nav-sidebar>
            }
        </div>
    </div>
    <div class="sidebar-setting">
        <div class="nav-link flex flex-col">
            @for (item of settingItemsData; track item.id) {
            <app-nav-sidebar [item]="item"></app-nav-sidebar>
            }
        </div>
        <div class="logout flex flex-row items-center">
            <button class="button flex flex-row items-center" (click)="logout()">
                <app-icon-svg width="24" height="24" iconName="logout" color="#e0074c"></app-icon-svg>
                Se déconnecter
            </button>
        </div>
    </div>
</div>